import { TCreateJobPostContextState } from './CreateJobPostContext';

export const createJobPostConfigSelectors = {
  createJobPostData: (state: TCreateJobPostContextState) => {
    return state.createJobPostData;
  },
  screeningQuestions: (state: TCreateJobPostContextState) => {
    return state.screeningQuestions;
  },
  editingQuestionId: (state: TCreateJobPostContextState) => {
    return state.editingQuestionId;
  },
  isOpenBackToHomeModal: (state: TCreateJobPostContextState) => {
    return state.isOpenBackToHomeModal;
  },
  isOpenAfterSubmitJobPostModal: (state: TCreateJobPostContextState) => {
    return state.isOpenAfterSubmitJobPostModal;
  },
  isOpenAddQuestionModal: (state: TCreateJobPostContextState) => {
    return state.isOpenAddQuestionModal;
  },
  isOpenJobSeekerApplyForJobPostModal: (state: TCreateJobPostContextState) => {
    return state.isOpenJobSeekerApplyForJobPostModal;
  },
  update: (state: TCreateJobPostContextState) => {
    return state.update;
  },
};
